import { Controller } from "@hotwired/stimulus"

// Simple dropdown that toggles a menu target and closes on outside click.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._outside = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    // Reset to closed on (re)connect — the feed is cacheable, so a back-nav
    // restore would otherwise show the menu still open from before you left.
    if (this.hasMenuTarget) this.menuTarget.style.display = "none"
  }

  disconnect() {
    document.removeEventListener("click", this._outside)
  }

  toggle(e) {
    e.stopPropagation()
    const open = this.menuTarget.style.display !== "none"
    open ? this.close() : this.open()
  }

  open() {
    this.menuTarget.style.display = "block"
    requestAnimationFrame(() => document.addEventListener("click", this._outside))
  }

  close() {
    this.menuTarget.style.display = "none"
    document.removeEventListener("click", this._outside)
  }
}
